const Pagination = {
  install(Vue, options) {
    const store = new Vue({
      data: {
        current: 0, // 現在のページ番号
        visible: 6, // ページネーションのリンクに表示するページ数
        total: 0, // ページの総数
        rows: 0, // データの総数
        rows_per_page: 100, // 1ページに表示するデータの件数
      },
    });

    function setTotal() {
      store.total = Math.ceil(store.rows / store.rows_per_page);
    }

    Vue.prototype.$page = {
      get current() {
        return store.current;
      },
      get visible() {
        return store.visible;
      },
      get total() {
        return store.total;
      },
      set current(num) {
        const current = num != null ? parseInt(num) : 1;
        store.current = Math.max(1, Math.min(current, store.total));
      },
      set rows(num) {
        store.rows = num != null ? parseInt(num) : 0;
        setTotal();
      },
      set rowsPerPage(num) {
        store.rows_per_page = num != null ? parseInt(num) : 0;
        setTotal();
      },
    };
  },
};
export default Pagination;



// WEBPACK FOOTER //
// ./src/plugins/pagination.js